import React from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import Statistics from "../../components/Statistics/Statistics";
import "./Dashboard.css";
import { AuthContext } from "../../context/Authcontext";
import { useNavigate } from "react-router-dom";

export default function Dashboard() {
  const navigate = useNavigate();
  const { user, loading } = React.useContext(AuthContext);

  if (loading) {
    return <div className="dashboard-container">Loading...</div>;
  }

  console.log("Dashboard user:", user);

  if (!user) {
    return navigate("/");
  }

  return (
    <div className="dashboard-container">
      <Sidebar />
      <main className="dashboard-content">
        <h1>Admin Dashboard</h1>
        <Statistics />
      </main>
    </div>
  );
}
